<template>
  <flow-layout :progress="37.5" :time="3">
    <heading level="2">
      {{ $t('additionalInfo.heading') }}
    </heading>
    <p class="note">
      {{ $t('additionalInfo.note') }}
    </p>
    <funding-needs />
    <statement-collect @electronicUploadSuccessful="onElectronicUploadSuccessful" />
    <funding-purposes />
    <navigation-buttons class="navigationButtons" @back="goBack" :next="true">
      <brand-button :disabled="disableButtonNext" slot="next" @click="submit">
        {{ $t('nextButtonLabel') }}
      </brand-button>
    </navigation-buttons>
  </flow-layout>
</template>
<script>
import { mapGetters } from 'vuex';
import { LOAN_AMOUNT_MIN, LOAN_AMOUNT_MAX } from '@/modules/validation-service/constants';
import FlowLayout from '@/views/layouts/FlowLayout';
import StatementCollect from '@/product-renewal-tl/views/application/AdditionalInfo/StatementCollect';
import FundingNeeds from '@/product-renewal-tl/views/application/AdditionalInfo/FundingNeeds';
import FundingPurposes from '@/product-renewal-tl/views/application/AdditionalInfo/FundingPurposes';
import applicationMixin from '@/mixins/application';
import uploadFilesMixin from '@/mixins/upload-files';
import { getApplicationAdrs, getApplicationOffers } from '@/modules/api-service/v3';
import { BAD_REQUEST } from '@/modules/api-error/types';
import { removeApplicationFromLocalStorage } from '@/utils/application-to-local-storage';

export const mapToKeyValue = ([key, value]) => ({ key, value });

export default {
  name: 'additional-info',
  components: {
    FlowLayout,
    StatementCollect,
    FundingNeeds,
    FundingPurposes,
  },
  data() {
    return {
      electronicUploadSuccessful: false,
    };
  },
  computed: {
    ...mapGetters('application', ['getUiStateApplication']),
    totalLoanAmount() {
      return Number(this.getUiStateApplication?.requestedAmount) || 0;
    },
    disableButtonNext() {
      return (
        this.totalLoanAmount > LOAN_AMOUNT_MAX ||
        this.totalLoanAmount < LOAN_AMOUNT_MIN ||
        (!this.electronicUploadSuccessful && !this.isThereSomeFilesUploaded && !this.application.brokerflowCode) ||
        this.isUploadInProgress ||
        (this.fileUploadServiceError && !this.isThereSomeFilesUploaded)
      );
    },
  },
  async created() {
    const { data: adrs } = await getApplicationAdrs(this.application.id);
    this.$store.dispatch('adrs/createAdrs', adrs);

    const { data: offers } = await getApplicationOffers(this.application.id);
    this.$store.dispatch('offer/deleteAll', null, { root: true });
    this.$store.dispatch('offer/createOffers', offers, { root: true });
  },

  // line below needed as methods [goBack, submit] are located in application mixin
  mixins: [applicationMixin, uploadFilesMixin],
  methods: {
    onElectronicUploadSuccessful() {
      this.electronicUploadSuccessful = true;
      this.application._extension.isStatementsManuallyUploaded = false;
    },
  },
  errorHandlers() {
    return {
      [BAD_REQUEST]: () => {
        removeApplicationFromLocalStorage();
        this.$router.replace({ name: 'unableProcess' });
      },
    };
  },
};
</script>
<style lang="sass">
.note
  margin: $glass-spacing-2 0

.heading
  padding-top: $glass-spacing-1

.navigationButtons
  margin-top: $glass-spacing-5
</style>
